'use client'

import Link from 'next/link';
import Image from 'next/image';

import { Button } from "@/components/ui/button";

import useEmblaCarousel from "embla-carousel-react";
import { EmblaOptionsType } from 'embla-carousel'
import Autoplay from "embla-carousel-autoplay";
import { MixpanelTracking } from '@/lib/mixpanel-browser-analytics';

export default function BlogArticles(){

    interface Article {
        
        title: string;
        image: number;
        date: string;
        url: string;
        description: string;

    }
    
    const articles: Article[] = [

        {
            title: 'Introduction',
            image: 0,
            date: 'December 30, 2023',
            url: 'https://medium.com/@bazaarroom.com/introduction-936be2c410cd',
            description: "Welcome to BazaarRoom — the platform that revolutionises the way you connect with your customers, no matter what skills you offer. If you're a skilled seller seeking more diverse opportunities, it's time to take control of your career and join us on BazaarRoom."

        },

        {
            title: 'Grab your phone, tablet or laptop, post your skills and start making money from anywhere!',
            image: 1,
            date: 'May 22, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/05/grab-your-phone-tablet-or-laptop-post.html',
            description: "We live in an era of opportunity, when pretty much anyone with a computer and an internet connection can supplement their income. Not only that, but"

        },

        {
            title: 'Artificial intelligence is leaving people without a job. What can we do?',
            image: 2,
            date: 'May 06, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/05/artificial-intelligence-is-leaving.html',
            description: "We've always tried to find ways to push the boundaries and deliver exceptional work. That's why it's very important to focus on what you can achieve and"

        },


        {
            title: 'What makes BazaarRoom different from other streaming services?',
            image: 3,
            date: 'May 04, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/05/what-makes-bazaarroom-different-from.html',
            description: "We all want to generate income online these days, and it's very important to ensure you always have access to a platform that helps you do that. BazaarRoom is here"

        },


        {
            title: 'The cheapest place where you can learn new things or sell skills',
            image: 4,
            date: 'May 04, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/05/the-cheapest-place-where-you-can-learn.html',
            description: "If we all know something about online learning, is that it can get quite expensive. There are a lot of platforms out there which sell very expensive courses, and those"

        },

        {
            title: 'My opinion about BazaarRoom and their services - (Review from Client)',
            image: 5,
            date: 'May 04, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/05/my-opinion-about-bazaarroom-and-their.html',
            description: "One of the toughest challenges for many of us these days is to figure out a way to earn more money. It can be difficult to do that, but there are a variety of"

        },

        {
            title: 'Benefits of using Bazaarroom.com for Retired Teachers',
            image: 6,
            date: 'April 22, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/04/benefits-of-using-bazaarroomcom-for.html',
            description: "Mentor other educators through on-line streaming services. Be a consulting educator"

        },

        {
            title: '5 Major Benefits Of Live Streaming Video in Marketing',
            image: 7,
            date: 'April 22, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/04/benefits-of-live-streaming-video-in.html',
            description: "Live video is a powerful means to share the story of your brand. Build relationships with key audiences, build customer loyalty, and."

        },

        {
            title: 'How To Effectively Market Your Products And Services Online',
            image: 8,
            date: 'April 22, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/04/how-to-effectively-market-your-products.html',
            description: "If you're reading this, then you're probably looking for ways to market your products and services online. Whether you're a small business or a large corporation"

        },

        {
            title: 'More than 1300 plus skills categories to earn from.',
            image: 9,
            date: 'April 21, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/04/more-than-1300-plus-skills-categories.html',
            description: "Finding customers for your business can be difficult, most of all when this business is service-providing. Customers equally suffer the same dilemma"

        },

        {
            title: 'Best Way To Do Video Advertising Of Your Business',
            image: 10,
            date: 'April 21, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/04/best-way-to-do-video-advertising-of.html',
            description: "If you are a business owner and want to make a small business a brand, then you should have content for your business online not only in the shape of a written advertisement but also"

        },

        {
            title: 'How to sell your skills and Get Paid',
            image: 11,
            date: 'April 21, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/04/how-to-sell-kills-and-get-paid.html',
            description: "Every living person has some skill he has achieved through his insight or experiences. It's now his responsibility to utilise this skill for the benefit of others. It will not only assist"

        },

        {
            title: 'How to Create Amazing Video Showcase Of Your Products',
            image: 12,
            date: 'April 21, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/04/how-to-create-amazing-video-showcase-of.html',
            description: "Every entrepreneur wants a big market to sell his product to make his business successful. Access to a big market and the maximum audience is only achieved through"

        },


        {
            title: 'Great Platform For Teachers To Share Skills',
            image: 13,
            date: 'April 21, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/04/great-platform-for-teachers-to-share.html',
            description: "Undoubtedly, technology has taken over all the fields of the world, including education. Online teaching and learning have become a regular part of the education field since the"

        },

        {
            title: 'How to Improve your skills and learn new ones!!!',
            image: 14,
            date: 'April 21, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/04/how-to-improve-your-skills-and-learn.html',
            description: "If you want to achieve success in life, then it's very important to not only learn new things, but also improve the skills you currently have."

        },

        {
            title: 'The Ultimate Guide To Learning Plumbing Online',
            image: 15,
            date: 'April 21, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/04/the-ultimate-guide-to-learning-plumbing.html',
            description: "If you want to learn to plumb, there's no better way than to do it online. There are plenty of websites that offer courses and"

        },


        {
            title: 'Where I can sell my skills online?',
            image: 16,
            date: 'April 21, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/04/the-best-website-to-share-your-skills.html',
            description: "An online skills sharing community is a place where people can share their skills and advice with others. This can be a great way to help others learn new skills, find resources, and"

        },

        {
            title: 'Incredible Product Selling Video Platform That You Must Try Today!',
            image: 17,
            date: 'April 21, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/04/incredible-product-selling-video.html',
            description: "One of the main benefits of using a product selling video platform is that it can increase sales. By creating videos that showcase your products and how they can help customers, you can help"

        },

        {
            title: 'How to make money from home with simple business ideas.',
            image: 8,
            date: 'April 21, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/04/how-to-make-money-from-home-with-simple.html',
            description: "There are many different types of business ideas that you can consider when starting a business. Here are five simple business ideas that you may find helpful"

        },

        {
            title: 'Turn Your Skills into Revenue Online!',
            image: 18,
            date: 'April 16, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/04/turn-your-skills-into-revenue-online.html',
            description: "Bazaar Room was established so that ambitious people like you, who have no experience in business and who do not like to take on the accountability of"

        },

        //New articles

        {
            title: 'Generate a great income and work from anywhere!!!',
            image: 19,
            date: 'September 12, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/09/generate-great-income-and-work-from.html',
            description: "Earning a great income is not dependent on where you live, nor do you need to worry about a lack of office space. What makes a platform like Bazaarroom great is"

        },


        {
            title: 'Join Bazaarroom today to start monetizing any of your skills.',
            image: 20,
            date: 'September 12, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/09/join-bazaarroom-today-to-start.html',
            description: "If there's one thing that we all need, that would be extra money. Our day to day life is becoming more and more expensive, so it's very difficult to figure out a way to properly"

        },

        {
            title: 'Learn how to make money online',
            image: 21,
            date: 'December 20, 2023',
            url: 'https://medium.com/@bazaarroom.com/learn-how-to-make-money-online-29da0613765e',
            description: "One of the core benefits of making money online is that with the right skills, you can generate a small fortune. The challenge comes from connecting with other people and"

        },

        {
            title: 'Why should you use Bazaarroom to sell your skills?',
            image: 22,
            date: 'September 12, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/09/why-should-you-use-bazaarroom-to-sell.html',
            description: "We all have a talent, and these days it has become easier than ever to sell these talents online, quick and easy. Whether you are a good carpenter, plumber, teacher or"

        },

        {
            title: 'The ultimate way to monetize ANY skill: Bazaarroom!',
            image: 23,
            date: 'September 12, 2023',
            url: 'https://bazaarroom.blogspot.com/2023/09/the-ultimate-way-to-monetize-any-skill.html',
            description: "We all know how difficult it is to earn money online these days with a simple skill. You need to learn a lot, adapt and figure out new ways to monetize the things you do. But you can still"

        },

        {
            title: 'Tools and Features: A Guide for Sellers',
            image: 24,
            date: 'December 29, 2023',
            url: 'https://medium.com/@bazaarroom.com/tools-and-features-a-guide-for-sellers-c90e8cbade73',
            description: "Selling your services on Bazaar Room is a great way to generate a good income and start helping others. What makes the platform incredible is that with your skills selling, you can"

        },

        {
            title: 'Global Marketplace',
            image: 25,
            date: 'December 29, 2023',
            url: 'https://medium.com/@bazaarroom.com/global-marketplace-9c9bdb769afe',
            description: "BazaarRoom is a thriving global marketplace where you can connect with people who have specific needs, advertise your skills, or simply offer your expertise"

        },

        {
            title: 'Video Advertising Of Your Business',
            image: 26,
            date: 'December 29, 2023',
            url: 'https://medium.com/@bazaarroom.com/video-advertising-of-your-business-d7a942a3dc11',
            description: "If you are a business owner and want to make a small business a brand, then you should have content for your business online not only in the shape of a written advertisement but"

        },

        {
            title: 'Story that Helps People Earn Extra Income',
            image: 27,
            date: 'January 28, 2024',
            url: 'https://medium.com/@bazaarroom.com/story-that-help-people-earn-extra-income-d3c3f1bc94f2',
            description: "Hi I would like to share a story with you about a new, and very unique platform. We believe this platform can help people earn additional income using- not offices with desks — but"

        },

        {
            title: "Don't Pass Up Opportunities.",
            image: 28,
            date: 'February 4, 2024',
            url: 'https://medium.com/@bazaarroom.com/dont-pass-up-opportunities-230ce4fd4077',
            description: "Hello everyone, if you are not interested in selling your abilities on our platform through streaming, that's okay. However, you may advertise your skills on BazaarRoom.com in the Business & Products area."

        },

        {
            title: "My Experience with Bazaar",
            image: 8,
            date: 'February 5, 2024',
            url: 'https://medium.com/@bazaarroom.com/my-experience-with-bazaarroom-com-6376ca70dbee',
            description: "Hey everyone I've been an auto parts supplier for over a decade. I've always liked the idea of connecting with people, offering them the best possible parts for their cars, while also assisting them in"

        },

        {
            title: "A Craftsman's Story.",
            image: 29,
            date: 'February 5, 2024',
            url: 'https://medium.com/@bazaarroom.com/a-craftsmans-story-680caa9a470b',
            description: "I am an independent craft artist and vendor in Jamaica. I always liked the idea of being part of a local business, but the problem was that most of the time you had to rely on others for space and materials"

        },

    ]

    
    const options : EmblaOptionsType = {
        slidesToScroll: 'auto',
        dragFree: true,
        containScroll: 'trimSnaps',
        loop: true,
        
    }
    const [emblaRef] = useEmblaCarousel(options, [Autoplay({ delay: 6000 })])

    

    return(
        <>


            
            <h1 className="text-5xl font-bold py-6 pl-[3.5rem]">Resources</h1>
            <h3 className="text-3xl font-semibold pt-10 pl-[3.5rem]">Blog Articles</h3>
            

            <hr className="h-[2px] bg-gray-100 border-0 mt-6 m-0" />

           
            <div className="embla px-[3rem]" >
                <div className="embla__viewport overflow-hidden" ref={emblaRef}>
                    <div className="embla__container flex touch-pan-y flex-row h-auto ml-[-0.75rem] lg:ml-[-4rem]">

                    {

                        articles.map((articleInfo, key)=> {

                            return(

                                <div className="embla__slide flex flex-col flex-wrap min-w-0 relative justify-between pl-3 flex-[0_0_100%] sm:flex-[0_0_50%] lg:flex-[0_0_33%] lg:pl-16 3xl:flex-[0_0_25%]" key={key}>

                                    

                                    <div className='max-w-[350px] rounded-b-xl overflow-hidden'>

                                        <Image
                                            src={`/images/blogArticlePic${articleInfo.image}.png`}
                                            className='embla__slide__img w-[75rem] h-auto rounded-b-xl'
                                            alt=""
                                            width={320}
                                            height={214}
                                        />

                                    </div>

                                    <div className='pt-5 max-w-[320px]'>

                                        <h1 className='text-2xl font-medium mb-5' >{articleInfo.title}</h1>

                                        <p className='text-zinc-400 mb-5'>{articleInfo.date}</p>

                                        <p className='whitespace-pre-line mb-5'>{articleInfo.description}...</p>


                                        <Link href={articleInfo.url} onClick={()=>MixpanelTracking.getInstance().blogArticleReadClicked(articleInfo.title)}>
                                            <Button className='uppercase tracking-widest font-medium w-[40%] transition-all scale-100 origin-left duration-300 hover:bg-blue-500 hover:scale-105'>
                                                Read
                                            </Button>
                                        </Link>

                                    </div>

                                 

                                </div>

                            )

                        }) 


                    }

                    </div>
                </div>
            </div>
            

            <hr className="h-[2px] bg-gray-100 border-0 mt-12 m-0" />

           
        
        </>

    )

}